import { FRANCHISE } from '~/constants/franchise';
import { Franchises } from '~/lib/data-contract';
import { EnvironmentName } from '~/shared/utils/public-variables/runtime-config';

enum EasysizeSiteIds {
    // Production sites
    toejeksperten = '05b4791ed2',
    wagner = 'bbe0d1dbe8',
    wagner_SE = '1f1bca5e34',
    lindbergh = 'a070ec3a28',
    junkdeluxe = '0fbba7a29b',
    bison = '383cccb969',
    brothers = '9c9646a961',

    // Local/test sites related to Umbraco platform
    test = 'd39005ae87',
}

export const EasysizeIdTable: {
    [key in Franchises]?: {
        [key in EnvironmentName]: string;
    };
} = {
    [FRANCHISE.WAGNER]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.wagner,
    },
    [FRANCHISE.TOEJEKSPERTEN]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.toejeksperten,
    },
    [FRANCHISE.WAGNER_SE]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.wagner_SE,
    },
    [FRANCHISE.LINDBERGH]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.lindbergh,
    },
    [FRANCHISE.JUNK_DE_LUXE]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.junkdeluxe,
    },
    [FRANCHISE.BISON]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.bison,
    },
    [FRANCHISE.BROTHERS]: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.brothers,
    },
};

export const EasysizeElementIds = {
    placeholder: 'easysize-placeholder',
    recommendation_placeholder: 'easysize-placeholder',
    add_to_cart_btn_selector: 'easysize-add-to-cart-button',
};
